import React, { useState } from 'react';
import SchemaFAQPage from './SchemaFAQPage';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Combien de temps pour créer un site web?",
      answer: "Un site vitrine simple est livré en 7-10 jours. Pour un e-commerce, comptez 2-3 semaines selon la complexité. Nous respectons toujours les délais convenus."
    },
    {
      question: "Le site sera-t-il adapté aux mobiles?",
      answer: "Absolument! Tous nos sites sont 100% responsive et s'adaptent parfaitement aux smartphones, tablettes et ordinateurs. C'est inclus dans tous nos forfaits."
    },
    {
      question: "Puis-je modifier mon site moi-même après?",
      answer: "Oui! Nous incluons une formation gratuite pour vous apprendre à gérer votre contenu. Pour les modifications techniques, nous restons disponibles avec notre support."
    },
    {
      question: "Quelles sont les étapes d'un projet?",
      answer: "1) Rendez-vous découverte (gratuit), 2) Devis détaillé, 3) Acompte 30%, 4) Création et validation, 5) Mise en ligne, 6) Formation et livraison, 7) Support post-lancement."
    },
    {
      question: "Proposez-vous la maintenance?",
      answer: "Oui! Notre forfait Assistance PME à 150€/mois inclut maintenance, mises à jour, sauvegardes et 4h de support. Nous proposons aussi des interventions ponctuelles."
    },
    {
      question: "Quels moyens de paiement acceptez-vous?",
      answer: "Virement bancaire, chèque, et espèces. Paiement en 3 fois sans frais possible pour les projets > 2000€. Acompte de 30% à la commande, solde à la livraison."
    },
    {
      question: "Travaillez-vous uniquement sur Roncq?",
      answer: "Nous intervenons dans toute la métropole lilloise: Roncq, Seclin, Lesquin, Templeuve, Cysoing, Orchies et Lille. Assistance à distance partout en France."
    },
    {
      question: "Quelle garantie offrez-vous?",
      answer: "100% satisfaction garantie. Support gratuit 1-3 mois selon le forfait. Correction des bugs pendant 6 mois. Nous ne considérons le projet terminé que quand vous êtes satisfait."
    }
  ];

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-32 px-4 sm:px-6 lg:px-8 relative">
      {/* Schema FAQPage pour le SEO */}
      <SchemaFAQPage faqs={faqs} />

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-20 fade-in">
          <div className="inline-block mb-4 px-4 py-1 rounded-full border border-[var(--accent)] bg-[rgba(255,0,229,0.1)] text-[var(--accent)] text-sm font-bold tracking-widest uppercase">FAQ</div>
          <h2 className="text-4xl sm:text-5xl font-bold mb-6 font-['Space_Grotesk'] text-white">
            Questions <span className="text-gradient-electric">Fréquentes</span>
          </h2>
          <p className="text-xl text-gray-400">
            Tout ce que vous devez savoir avant de nous contacter
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="glass-panel rounded-2xl overflow-hidden fade-in border-[var(--border-glass)] hover:border-[var(--primary)]/50 transition-colors duration-300">
              <button
                onClick={() => toggleQuestion(index)}
                className="w-full px-8 py-6 text-left flex justify-between items-center hover:bg-white/5 transition-colors"
              >
                <span className="font-bold text-white text-lg pr-4 font-['Space_Grotesk']">{faq.question}</span>
                <span className={`text-[var(--primary)] text-3xl flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                  +
                </span>
              </button>
              <div 
                className={`px-8 transition-all duration-300 ease-in-out overflow-hidden ${openIndex === index ? 'max-h-96 pb-8 opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <p className="text-gray-300 leading-relaxed border-t border-white/5 pt-4">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 glass-panel rounded-3xl p-10 sm:p-12 text-center fade-in border-[var(--primary)]/30 shadow-[0_0_50px_rgba(112,0,255,0.1)]">
          <h3 className="text-3xl font-bold text-white mb-4 font-['Space_Grotesk']">
            Vous avez d'autres questions?
          </h3>
          <p className="text-gray-400 mb-10 text-lg">
            N'hésitez pas à nous contacter, nous répondons sous 24h!
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-6">
            <a href="tel:+33689177385" className="bg-transparent border border-[var(--primary)] text-[var(--primary)] hover:bg-[var(--primary)] hover:text-white px-8 py-4 rounded-xl font-bold transition-all inline-flex items-center justify-center gap-3 uppercase tracking-wider text-sm">
              <span>📞</span>
              <span>06 89 17 73 85</span>
            </a>
            <a href="#contact" className="btn-magnetic bg-[var(--primary)] hover:bg-[var(--primary-dark)] text-white px-8 py-4 rounded-xl font-bold transition-all shadow-lg shadow-purple-500/25 uppercase tracking-wider text-sm">
              Formulaire de Contact
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQ;